import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { LegalPage, H2, P, UL } from '../components/LegalPage';

const CachodicePrivacy = () => {
  const { lang } = useLanguage();

  if (lang === 'en') {
    return (
      <LegalPage
        testid="cachodice-privacy-en"
        eyebrow="CachoDice"
        title="Privacy Policy"
        subtitle="Operated by Inversiones Tair SpA"
        lastUpdated="Last updated: December 2026"
        backTo="/cachodice"
        backLabel="Back · CachoDice"
      >
        <P>
          <strong className="text-white">CachoDice</strong> is operated by{' '}
          <strong className="text-white">Inversiones Tair SpA</strong> (Chile).
        </P>

        <H2>1. We do not collect personal data</H2>
        <P>
          CachoDice works without our own servers. Multiplayer matches use Apple&#39;s Multipeer
          Connectivity, a direct connection between nearby devices (P2P). Your player name and match
          data are shared only with the players in the same room and are never sent to or stored on
          any of our servers.
        </P>

        <H2>2. No ads and no tracking</H2>
        <P>We do not use trackers or third-party analytics tools.</P>

        <H2>3. In-app purchase</H2>
        <P>
          The full version ($2.99) is handled directly by Apple through StoreKit / the App Store. We
          do not receive or store your card or payment data; those data are handled by Apple under
          their own policy.
        </P>

        <H2>4. Data stored on your device</H2>
        <P>
          Your trial/purchase status and your preferences are stored locally on your device
          (UserDefaults) and never leave it.
        </P>

        <H2>5. Minors</H2>
        <P>
          The App is not directed to collect information from minors and does not collect personal
          data from any user.
        </P>

        <H2>6. Contact</H2>
        <P>
          Controller: <strong className="text-white">Inversiones Tair SpA</strong> ·{' '}
          <a href="mailto:info@tair.site" className="text-amber-300 hover:text-amber-200">info@tair.site</a>
        </P>
      </LegalPage>
    );
  }

  return (
    <LegalPage
      testid="cachodice-privacy-es"
      eyebrow="CachoDice"
      title="Política de Privacidad"
      subtitle="Operada por Inversiones Tair SpA"
      lastUpdated="Última actualización: Diciembre 2026"
      backTo="/cachodice"
      backLabel="Volver · CachoDice"
    >
      <P>
        <strong className="text-white">CachoDice</strong> es operada por{' '}
        <strong className="text-white">Inversiones Tair SpA</strong> (Chile).
      </P>

      <H2>1. No recopilamos datos personales</H2>
      <P>
        CachoDice funciona sin servidores propios. Las partidas multijugador usan{' '}
        <strong className="text-white">Multipeer Connectivity</strong> de Apple, una conexión directa
        entre dispositivos cercanos (P2P). Tu nombre de jugador y los datos de la partida se
        comparten sólo con los jugadores de tu misma sala y no se envían ni almacenan en ningún
        servidor nuestro.
      </P>

      <H2>2. Sin publicidad y sin seguimiento</H2>
      <P>No usamos rastreadores ni herramientas de analítica de terceros.</P>

      <H2>3. Compras dentro de la app</H2>
      <P>
        La versión completa (<strong className="text-white">$2.99</strong>) se gestiona directamente
        por Apple mediante StoreKit / App Store. No recibimos ni almacenamos datos de tu tarjeta ni
        de pago; esos datos los maneja Apple según su propia política.
      </P>

      <H2>4. Datos guardados en tu dispositivo</H2>
      <P>
        El estado de tu prueba/compra y tus preferencias se guardan localmente en tu dispositivo
        (UserDefaults) y no salen de él.
      </P>

      <H2>5. Menores</H2>
      <P>
        La App no está dirigida a recolectar información de menores y no recopila datos personales
        de ningún usuario.
      </P>

      <H2>6. Contacto</H2>
      <P>
        Responsable: <strong className="text-white">Inversiones Tair SpA</strong>
      </P>
      <P>
        Correo:{' '}
        <a href="mailto:info@tair.site" className="text-amber-300 hover:text-amber-200">info@tair.site</a>
      </P>
    </LegalPage>
  );
};

export default CachodicePrivacy;
